$(function() {
  var MOBILE_CUTOFF = 768;
  var DAYS_IN_FUTURE = 30;
  var modal = $('.js-newsletter-signup');

  if ( modal.length > 0 ) {
    var seenPromo = docCookies.getItem('seenPromo') || false;
    var expDate = new Date();

    if ( seenPromo !== '1'  && $(window).width() > MOBILE_CUTOFF ) {
      // only show the signup form on medium-up devices that haven't seen it before
      expDate.setDate(expDate.getDate() + DAYS_IN_FUTURE);
      docCookies.setItem('seenPromo', '1', expDate, null, null, 'bluestoneperennials.com');
      modal.modal();
    }
  }

  modal.on('submit', '.js-newsletter-signup-form', function(e) {
    e.preventDefault();
    var form = $(this);
    var msgHtml;
    $.ajax({
      url: form.attr('action'),
      method: 'post',
      data: form.serialize(),
      success: function(d,s) {
        if ( s === 'success' && /success|existing/.test(d.status) ) {
          modal.find('.js-newsletter-status-msg').html();
          msgHtml = '<span class="msg--success">' + d.msg + '</span>';
          window.setTimeout(function() {
            modal.modal('hide');
          }, 4000);
        }

        else {
          msgHtml = '<span class="msg--fail">' + d.msg + '</span>';
        }

        modal.find('.js-newsletter-cta').remove();
        $('.js-newsletter-status-msg').html('<span class="msg--fail">' + d.msg + '</span>');

      },
      error: function() {
        console.error('There was a problem with the newsletter signup request.');
      }
    });
  });

  $("#footer-signup-form").on('submit', function(e) {
    e.preventDefault();
    var form = $(this);

    $.ajax({
      url: form.attr('action'),
      method: 'post',
      data: form.serialize(),
      success: function(d,s) {
        if ( /success|existing/.test(d.status) ) {
          $('.footer-signup-msg').html('<span class="msg--success">'+ d.msg + '</span>');
          $('.footer-signup-msg').show();
          $('.footer-signup-msg').fadeOut(4000);
        }

        else {
          $('.footer-signup-msg').html('<span class="msg--fail">' + d.msg + '</span>');
          $('.footer-signup-msg').show();
          $('#footer-email').focus();
        }
      },
      error: function() {
      }
    });
  });

  $('body').on('click', '.js-resubscribe', function() {
    if ( modal.is(':visible') )  {
      window.setTimeout(function() {
        modal.modal('hide');
      }, 5000);
    }
  })
});
